import CustomPortal from "../../CustomPortal";
import ResetSuccess from '../../reset-password-component/ResetSuccess';

const ResetSuccessForm = () => {
    return (
        <CustomPortal
            header="Password reset successfully"
            Component={ResetSuccess}
            showStatus={true}
        />
    );
}

export default ResetSuccessForm;